import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import { __isEnvDev } from '../config'

const JsonModal = (props) => {
  const { close, content, isModalDialogOpen, title } = props
  let rawData = null
  const isString = typeof content === 'string' || content instanceof String
  const isObject = typeof content === 'object' || content instanceof Object

  if (content) {
    try {
      if (isString) {
        rawData = JSON.stringify(JSON.parse(content), null, 2)
      } else if (isObject) {
        rawData = JSON.stringify(content, null, 2)
      } else {
        rawData = 'Error: decoding failed'
        if (__isEnvDev()) {
          console.log('Error: cannot create JSON string from given datatype')
        }
      }
    } catch (e) {
      if (__isEnvDev) {
        console.log(e)
      }
      if (e instanceof SyntaxError && isString) {
        rawData = content
      }
    }
  }

  return (
    <Modal size={'lg'} show={isModalDialogOpen} onHide={close}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ wordWrap: 'break-word' }}>
        <pre>{rawData}</pre>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={close} variant={'default'}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default JsonModal
